// src/components/events/EventTypeChips.js
// Вкладки-чипсы подтипов событий (мобильный лист и десктопный диалог)
import React, { useEffect, useRef, useState } from "react";
import { Box, ButtonBase } from "@mui/material";
import { CARD_LABEL_COLOR, hexToRgb } from "../../styles/tokens";
import { EVENT_TYPE_NAMES } from "./eventMeta";

const FADE_MASK = "linear-gradient(90deg, #000 85%, transparent)";

function EventTypeChips({ eventTypes, events, activeTab, onChange, accent, sx }) {
  const accentRgb = hexToRgb(accent);
  const listRef = useRef(null);
  const [moreRight, setMoreRight] = useState(false);

  // Затухание правого края, пока чипсы не пролистаны до конца
  const updateFade = () => {
    const el = listRef.current;
    if (!el) return;
    setMoreRight(el.scrollLeft + el.clientWidth < el.scrollWidth - 1);
  };

  useEffect(() => {
    // Ждём отрисовки чипсов, потом меряем
    const frame = requestAnimationFrame(updateFade);
    window.addEventListener("resize", updateFade);
    return () => {
      cancelAnimationFrame(frame);
      window.removeEventListener("resize", updateFade);
    };
  }, [eventTypes.length]);

  if (eventTypes.length === 0) return null;

  return (
    <Box
      ref={listRef}
      role="tablist"
      onScroll={updateFade}
      sx={{
        flexShrink: 0,
        display: "flex",
        gap: 1,
        overflowX: "auto",
        scrollbarWidth: "none",
        "&::-webkit-scrollbar": { display: "none" },
        ...(moreRight && { maskImage: FADE_MASK, WebkitMaskImage: FADE_MASK }),
        ...sx,
      }}
    >
      {eventTypes.map((type) => {
        const selected = type === activeTab;
        const count = events.filter((e) => e.type === type).length;
        return (
          <ButtonBase
            key={type}
            role="tab"
            aria-selected={selected}
            onClick={() => onChange(type)}
            sx={{
              flexShrink: 0,
              height: 36,
              px: "14px",
              borderRadius: "18px",
              fontSize: "14px",
              fontWeight: 600,
              whiteSpace: "nowrap",
              backgroundColor: selected ? `rgba(${accentRgb},0.16)` : "rgba(255,255,255,0.06)",
              color: selected ? accent : CARD_LABEL_COLOR,
              "&.Mui-focusVisible": { outline: `2px solid ${accent}`, outlineOffset: "2px" },
            }}
          >
            {`${EVENT_TYPE_NAMES[type] || type} (${count})`}
          </ButtonBase>
        );
      })}
    </Box>
  );
}

export default EventTypeChips;
